// extracted by mini-css-extract-plugin
export default {"stockFooter":"StockFooter_stockFooter__3jc6z","imageContainer":"StockFooter_imageContainer__2qw12"};